module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_01_770_280_ja-8e6b68ac5e6462a8cb59b4251b8eb0c8.jpg";